import GenericMenuProps from './GenericMenu.props';
import {breakpoints} from '../../../types/grid/Breakpoints';
import DesktopMenu from '../desktop-menu/DesktopMenu';
import {MobileMenu} from '../mobile-menu/MobileMenu';

export const GenericMenu = (props: GenericMenuProps) =>
  props.width >= (breakpoints.md.minWidth ?? 0) ? <DesktopMenu {...props} /> : <MobileMenu {...props} />;
